import React, { useEffect, useRef, useState } from 'react'
import {
  useHistory,
  useLocation,
  withRouter,
  RouteComponentProps
} from 'react-router-dom'
import { toast, ToastOptions } from 'react-toastify'

import {
  ResumoDeDocumentosDeSaidaMapper,
  selecaoDeDocumentosParaEnvio,
  UploadDocumentos,
  useRelacaoDeDocumentos
} from 'src/compartilhados'
import { RelacaoDocumentosProfessorCertificacao } from 'src/compartilhados/modulos/gestao-de-documentos/data/relacao-de-documentos-professor-certificacao.data'
import {
  FormUnform,
  Botao,
  Breadcrumb,
  Cabecalho,
  focarPrimeiroCampoOuEditorComErro,
  IconeBack,
  Link,
  ModalRef,
  SelectOpcao,
  SubTitulo,
  InputUnform,
  Spacer,
  Modal,
  ErroLayoutContainer,
  AutenticacaoContainer,
  Visao
} from 'src/componentes'
import { SelectUnform } from 'src/componentes/unform/select'
import { CursoCertificacaoPayload, ProfessorCertificacaoPayload } from 'src/dto'
import { ContainerDadosGrande } from 'src/paginas/professor/meu-cadastro/styles'
import { RotasProfessorCertificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import { TipoTurmaCertificacao, Escolaridade } from 'src/tipos'
import { ModoPaginaCadastro } from 'src/tipos/genericos'

import { ContainerCertificacao } from '../../styles'
import DocumentosProfessorCertificacao, {
  DocumentosProfessorCertificacaoHandles
} from './componentes/documentos/documentos-professor-certificacao'
import { createSchema } from './schema'
import {
  Container,
  ContainerMain,
  ContainerDadosMedio,
  Conteudo,
  ContainerDados,
  ContainerAcoes,
  FormContainer,
  ContainerLink,
  SecaoPrimaria
} from './styles'

// import { DocumentosAlunoCertificacaoHandles } from './componentes/documentos/documentos-aluno-certificacao'
export interface PaginaTurmaCertificacaoProps
  extends RouteComponentProps<{
    id?: string
    tipo?: TipoTurmaCertificacao
  }> {
  modo?: ModoPaginaCadastro
}

const PaginaProfessores: React.FC<PaginaTurmaCertificacaoProps> = ({
  match,
  modo
}) => {
  const { visao } = AutenticacaoContainer.useContainer()
  const modalRef = useRef<ModalRef>(null)
  const documentosRef = useRef<DocumentosProfessorCertificacaoHandles>(null)
  const usuario = localStorage.getItem('@ipgs/usuario')
  const usuarioObj = JSON.parse(usuario)
  const [idProfessor, setIdProfessor] = useState<string>()
  const usuarioId = usuarioObj.id
  const [professor, definirProfessor] = useState<
    ProfessorCertificacaoPayload | undefined
  >(undefined)
  const [titulo] = useState(
    `${
      modo === ModoPaginaCadastro.Inclusao ? 'Inclusão' : 'Edição'
    } do Professor`
  )
  const history = useHistory()
  const { documentos, atualizar, reiniciar } = useRelacaoDeDocumentos(
    RelacaoDocumentosProfessorCertificacao
  )
  const [pronto, definirPronto] = useState(true)

  const erroAoEnviarDocumentos = 'Erro ao enviar documentos.'
  const erroAoAtualizarDocumentos = 'Erro ao atualizar documentos.'
  const erroAoEnviarMotivoAlteracaoAprovado = 'Erro ao enviar motivo alteração'

  const toastOptions = { type: 'error' } as ToastOptions

  const [carregando, definirCarregando] = useState(false)
  const [carregandoTudo, setCarregandoTudo] = useState(true)

  useEffect(() => {
    if (modo === ModoPaginaCadastro.Edicao) {
      setIdProfessor(match.params.id)
    }
  }, [])

  const carregarProfessor = async () => {
    try {
      const professorParaEdicao = await Api.RequisitarProfessorCertificacao(
        match.params.id
      )
      const professorCertificacao = professorParaEdicao as ProfessorCertificacaoPayload
      definirProfessor(professorCertificacao)
    } catch (error) {
      // eslint-disable-next-line
      console.log(error)
    } finally {
      definirPronto(true)
    }
  }

  const focarNoPrimeiroErro = (idContexto?: string): void => {
    setTimeout(() => {
      const selecaoDoEditor = '#informacoes-container > #erro-informacoes'
      return focarPrimeiroCampoOuEditorComErro(selecaoDoEditor)(idContexto)
    }, 0)
  }

  useEffect(() => {
    const carregarDados = async () => {
      try {
        // const turmas = await Api.RequisitarTodasTurmasCertificacao(usuarioId)
        // const opcoesFormatadas = turmas.map((turma: any) => ({
        //   id: turma.id,
        //   texto: turma.nome
        // }))
        // setOpcoesTurma(opcoesFormatadas)
        // definirTurmas(turmas)

        if (modo === ModoPaginaCadastro.Edicao) {
          const professorParaEdicao = await Api.RequisitarProfessorCertificacao(
            match.params.id
          )
          definirProfessor(professorParaEdicao)
          // definirOpcaoTCC(professorParaEdicao.tcc === 'true')
        }
      } finally {
        setCarregandoTudo(false)
      }
    }

    carregarDados()
  }, [usuarioId])

  const uploadDeCriacao = async (
    professorId: string,
    documentos: UploadDocumentos[]
  ): Promise<void> => {
    try {
      const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
      const resposta = await Api.EnviarDocumentosProfessorCertificacao(
        professorId,
        formulario
      )

      if (!resposta) {
        toast(erroAoEnviarDocumentos, toastOptions)
      }
    } catch (erro) {
      toast(erroAoEnviarDocumentos, toastOptions)
    }
  }

  const uploadDeEdicao = async (
    professorId: string,
    documentos: UploadDocumentos[]
  ): Promise<void> => {
    try {
      const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
      const resposta = await Api.EditarDocumentosProfessorCertificacao(
        professorId,
        formulario
      )

      if (resposta) {
        const documentosAprovados = documentos.filter(
          x => x.motivoAlteracaoAprovado
        )

        if (documentosAprovados?.length > 0) {
          try {
            await Api.AlteracaoAprovado(professorId, documentosAprovados)
          } catch {
            toast(erroAoEnviarMotivoAlteracaoAprovado, toastOptions)
          }
        }
      } else {
        toast(erroAoAtualizarDocumentos, toastOptions)
      }
    } catch (erro) {
      toast(erroAoAtualizarDocumentos, toastOptions)
    }
  }

  const acaoSucesso = async (professor: ProfessorCertificacaoPayload) => {
    try {
      definirCarregando(true)

      const { edicoes, criacoes, contador } = selecaoDeDocumentosParaEnvio(
        documentos
      )

      if (modo === ModoPaginaCadastro.Inclusao) {
        const response = await Api.InserirProfessorCertificacao(
          professor,
          usuarioId
        )
        setIdProfessor(response.professorId)

        if (contador !== 0) {
          uploadDeCriacao(response.professorId, criacoes)
        }
      } else {
        // const alunoPayload = {
        //   ...professor,
        //   divisao: cursoTurmaAluno?.divisao
        // }

        await Api.EditarProfessorCertificacao(
          match.params.id,
          professor,
          usuarioId
        )

        if (contador !== 0) {
          if (criacoes.length > 0) {
            await uploadDeCriacao(match.params.id, criacoes)
          }

          if (edicoes.length > 0) {
            await uploadDeEdicao(match.params.id, edicoes)
          }
        }
        setIdProfessor(match.params.id)
      }

      history.push(RotasProfessorCertificacao.Professores)
    } finally {
      definirCarregando(false)
    }
  }

  useEffect(() => {
    if (modo === ModoPaginaCadastro.Edicao && match.params.id) {
      carregarProfessor()
    }
  }, [usuarioId, modo, match.params.id])

  // useEffect(() => {
  //   if (modo === ModoPaginaCadastro.Edicao && match.params.id) {
  //     carregarAluno()
  //   }
  // }, [modo, match.params.id])

  const isParceiro = visao === Visao.ParceiroCertificacao

  return (
    <ContainerCertificacao>
      {pronto ? (
        <Container>
          <ContainerMain>
            <ContainerLink>
              <Link
                texto="Voltar"
                href={RotasProfessorCertificacao.Professores}
                icone={IconeBack}
              />
            </ContainerLink>
            <Cabecalho>
              <Breadcrumb
                titulo={titulo}
                atalhos={[
                  {
                    texto: 'Acadêmico',
                    acao: () => history.goBack()
                  },
                  {
                    texto: 'Professores',
                    acao: () => history.goBack()
                  },
                  {
                    texto: titulo
                  }
                ]}
              />
            </Cabecalho>
            <Conteudo>
              <FormContainer>
                <FormUnform
                  key={professor?.id ?? professor?.nome}
                  schema={createSchema}
                  dadosIniciais={professor}
                  acaoSucesso={acaoSucesso}
                  acaoFalha={focarNoPrimeiroErro}
                >
                  <SecaoPrimaria>
                    <SubTitulo texto="Dados do Professor" />
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <InputUnform
                          name="nome"
                          label="Nome"
                          obrigatorio
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <InputUnform
                          name="cpf"
                          label="CPF"
                          obrigatorio
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      {/* <ContainerDadosMedio>
                        <InputUnform
                          name="email"
                          label="Email"
                          obrigatorio
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio> */}
                      <ContainerDadosMedio>
                        <SelectUnform
                          className="lg"
                          id="escolaridade"
                          name="escolaridade"
                          label="Escolaridade"
                          placeholder="Selecione"
                          disabled={!isParceiro || carregando}
                          opcoes={[
                            {
                              id: `${Escolaridade.Doutorado}`,
                              texto: 'Doutorado'
                            },
                            {
                              id: `${Escolaridade.Especializacao}`,
                              texto: 'Especialização'
                            },
                            {
                              id: `${Escolaridade.Mestrado}`,
                              texto: 'Mestrado'
                            }
                            // {
                            //   id: `${Escolaridade.PosDoutorado}`,
                            //   texto: 'Pós Doutorado'
                            // }
                          ]}
                          obrigatorio
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <InputUnform
                          name="profissao"
                          label="Profissão"
                          obrigatorio
                          maxLength={200}
                          disabled={!isParceiro || carregando}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosGrande>
                        <InputUnform
                          type="text"
                          name="lattes"
                          label="Link do Lattes"
                          defaultValue="http://lattes.cnpq.br"
                          maxLength={200}
                          disabled={!isParceiro || carregando}
                        />
                      </ContainerDadosGrande>
                    </ContainerDados>
                    {/* <ContainerDados style={{ marginBottom: '20px' }}>
                      <ContainerDadosGrande>
                        <TextAreaUnform
                          name="aptidoes"
                          label="Aptidões"
                          maxLength={200}
                          obrigatorio
                          disabled={!isParceiro || carregando}
                        />
                      </ContainerDadosGrande>
                    </ContainerDados> */}
                    <ContainerDados>
                      <ContainerDadosGrande>
                        <ErroLayoutContainer.Provider>
                          <DocumentosProfessorCertificacao
                            ref={documentosRef}
                            professorCertificacaoId={idProfessor}
                            documentos={documentos}
                            atualizar={atualizar}
                            reiniciar={reiniciar}
                          />
                        </ErroLayoutContainer.Provider>
                      </ContainerDadosGrande>
                    </ContainerDados>
                  </SecaoPrimaria>
                  <Spacer padding="10px 0px" />
                  <ContainerAcoes>
                    <Botao
                      texto={'Cancelar'}
                      tema="Secundario"
                      type="button"
                      disabled={carregando}
                      onClick={() =>
                        isParceiro
                          ? modalRef.current?.abrir()
                          : history.push(RotasProfessorCertificacao.Professores)
                      }
                    />
                    <Botao
                      type="submit"
                      texto="Salvar"
                      carregando={carregando}
                    />
                  </ContainerAcoes>
                </FormUnform>
              </FormContainer>
            </Conteudo>
          </ContainerMain>
          <Modal
            ref={modalRef}
            backdrop
            id="modal-confirmacao-cancelamento"
            icone={<></>}
            titulo={'Deseja cancelar?'}
            acaoPrimaria={{
              titulo: 'Sim',
              tipo: 'button',
              acao: () => history.goBack()
            }}
            acaoSecundario={{
              titulo: 'Não',
              tipo: 'button',
              acao: () => modalRef.current?.fechar()
            }}
          >
            <p>Selecione uma opção</p>
          </Modal>
        </Container>
      ) : (
        <></>
      )}
    </ContainerCertificacao>
  )
}

export default withRouter(PaginaProfessores)
